import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Send, Loader2 } from 'lucide-react';
import { inputClass, labelClass, thClass, tdClass } from './adminUi';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminNewsletter = () => {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [campaign, setCampaign] = useState({ subject: '', html: '' });
  const [sending, setSending] = useState(false);

  const load = () =>
    axios
      .get(`${API}/admin/newsletter`)
      .then((r) => setSubs(Array.isArray(r.data) ? r.data : r.data.subscribers || []))
      .catch(() => toast.error('Échec du chargement des abonnés'))
      .finally(() => setLoading(false));

  useEffect(() => {
    load();
  }, []);

  const send = async (e) => {
    e.preventDefault();
    if (!campaign.subject.trim() || !campaign.html.trim()) {
      toast.error('Sujet et contenu requis');
      return;
    }
    setSending(true);
    try {
      await axios.post(`${API}/admin/newsletter/campaign`, { subject: campaign.subject, html: campaign.html });
      toast.success('Campagne demandée — envoi en cours');
      setCampaign({ subject: '', html: '' });
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erreur');
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid="admin-newsletter" className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      <div>
        <h2 className="font-heading text-2xl mb-6">Abonnés ({subs.length})</h2>
        {loading ? (
          <p className="text-foreground/40">Chargement…</p>
        ) : subs.length === 0 ? (
          <p className="text-foreground/40 py-8">Aucun abonné.</p>
        ) : (
          <div className="overflow-x-auto border border-black/10 max-h-[500px]">
            <table className="w-full">
              <thead><tr><th className={thClass}>Email</th><th className={thClass}>Source</th><th className={thClass}>Depuis</th></tr></thead>
              <tbody>
                {subs.map((s, i) => (
                  <tr key={s.email || i}>
                    <td className={tdClass}>{s.email}</td>
                    <td className={tdClass}>{s.source || '—'}</td>
                    <td className={tdClass}>{(s.subscribed_at || s.created_at || '').slice(0, 10) || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <div>
        <h2 className="font-heading text-2xl mb-6">Envoyer une campagne</h2>
        <form onSubmit={send} className="space-y-4">
          <div>
            <label className={labelClass}>Sujet *</label>
            <input className={inputClass} value={campaign.subject} onChange={(e) => setCampaign({ ...campaign, subject: e.target.value })} data-testid="campaign-subject" />
          </div>
          <div>
            <label className={labelClass}>Contenu HTML *</label>
            <textarea className={`${inputClass} min-h-[220px] font-mono text-sm`} value={campaign.html} onChange={(e) => setCampaign({ ...campaign, html: e.target.value })} placeholder="<h1>Nos nouveautés…</h1>" data-testid="campaign-html" />
          </div>
          <button type="submit" disabled={sending} className="btn-primary inline-flex items-center gap-2" data-testid="campaign-send">
            {sending ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />} Envoyer à {subs.length} abonné(s)
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminNewsletter;
